import React from 'react';
import { Col, Row, Panel, Button } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classNames from 'classnames';

/**
 * General Purpose Tile
 *
 * Right now this is being used to represent (shows, schedules, and lists) in
 * the create new modal.
 */
export default React.createClass({
  propTypes: {
    active: React.PropTypes.bool,
    icon: React.PropTypes.string,
    title: React.PropTypes.string,
    description: React.PropTypes.string,
    handleClick: React.PropTypes.func,
    enableBtn: React.PropTypes.bool,
    handleBtnClick: React.PropTypes.func,
    btnText: React.PropTypes.string,
  },

  displayName: 'Tile',

  render() {
    let classes = classNames('tile', this.props.classes, {
      active: this.props.active,
    });

    let tileBtn = this.props.enableBtn ? (
      <Row>
        <Col md={24}>
          <Button className="tile-btn" onClick={this.props.handleBtnClick}>
            {this.props.btnText}
          </Button>
        </Col>
      </Row>
    ) : null;

    return (
      <Col md={24}>
        <Panel className={classes} onClick={this.props.handleClick}>
          <Row>
            <Col className="tile-active-icon" md={24}>
              <Icon name="check" size="sm" />
            </Col>
          </Row>
          <Row>
            <Col className="tile-primary-icon" md={24}>
              <Icon name={this.props.icon} size="lg" />
            </Col>
          </Row>
          <Row>
            <Col className="tile-title" md={24}>
              <h4>{this.props.title}</h4>
            </Col>
          </Row>
          <Row>
            <Col className="tile-description" md={24}>
              <p>{this.props.description}</p>
            </Col>
          </Row>
          {tileBtn}
        </Panel>
      </Col>
    );
  },
});
